export const magenta = {
  100: 'var(--bfc-v2-color-magenta-100, #ffecf8)',
  200: 'var(--bfc-v2-color-magenta-200, #fdd0ec)',
  300: 'var(--bfc-v2-color-magenta-300, #f797d2)',
  400: 'var(--bfc-v2-color-magenta-400, #e774bb)',
  500: 'var(--bfc-v2-color-magenta-500, #da62ac)',
  600: 'var(--bfc-v2-color-magenta-600, #cd519d)',
  700: 'var(--bfc-v2-color-magenta-700, #ae4787)',
  800: 'var(--bfc-v2-color-magenta-800, #943d73)',
  900: 'var(--bfc-v2-color-magenta-900, #50253f)',
  1000: 'var(--bfc-v2-color-magenta-1000, #3d2232)',
  DEFAULT: 'var(--bfc-v2-color-magenta-700, #ae4787)', // 700
};
